import { bosCustomerFragment, customerFragmentWithBos, referenceFragment } from 'next-common';

export const queryOrderWithLead = `
  query findOrderById($id: ID!) {
    findOrderById(id: $id) {
      id
      lead {
        customerId
        make
        modelSeries
      }
      customer {
        ...customer
      }
      __typename
    }
  }
  ${referenceFragment}
  ${customerFragmentWithBos}
  ${bosCustomerFragment}
  fragment vehicle on Vehicle {
    id
  }
`;
